import { ChangeDetectionStrategy, Component } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'hh-samsung-health-overview-widget',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './samsung-health-overview-widget.component.html',
  styleUrls: ['./samsung-health-overview-widget.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SamsungHealthOverviewWidgetComponent {}
